import React, { Fragment, useState } from 'react';
import Navbar from './components/layout/Navbar';
import Alert from './components/layout/Alerts';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Register from './components/auth/Register';
import Login from "./components/auth/Login";
import Memory from "./components/pages/Memory";
import Gallery from "./components/pages/Gallery";
import Profile from "./components/pages/Profile";
import Manage from "./components/manage/Manage";
import Destination from './components/pages/Destination';


import PrivateRoute from "./components/routing/PrivateRoute";
import PostState from "./context/post/PostState";
import AuthState from './context/auth/AuthState';
import AlertState from "./context/alert/AlertState";
import TagState from "./context/tag/TagState";

import "./App.css";
import FollowingFeed from './components/pages/FollowingFeed';
import ManageFollowing from './components/pages/ManageFollowing';
import Spot from "./components/pages/Spot";
import CreateSpotReview from "./components/pages/CreateSpotReview";
import DestinationState from './context/destination/DestinationState';
import TripState from './context/trip/TripState';
import FriendState from './context/friending/FriendState';
import SpotReviewState from './context/spot/SpotReviewState';
import AdminState from './context/admin/AdminState';
import SpotDetails from './components/pages/SpotDetails';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import LeftNav from './components/layout/LeftNav';
import TripDetail from './components/pages/TripDetail';
import CreateTrip from './components/pages/CreateTrip';
import DestinationTrips from './components/pages/DestinationTrips';
import MyJourneys from './components/pages/MyJourneys';
import SpotReviewDetail from './components/pages/SpotReviewDetail';

const App = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleMenuToggle = () => setMobileOpen(!mobileOpen);
  const handleMobileClose = () => setMobileOpen(false);

  return (
    <AuthState>
      <PostState>
        <SpotReviewState>
          <DestinationState>
            <TripState>
              <TagState>
                <FriendState>
                  <AdminState>
                  <AlertState>
                    <Router>
                      <Fragment>
                        <Box sx={{ display: 'flex' }}>
                          <CssBaseline />
                          <Navbar onMenuToggle={handleMenuToggle} />
                          <LeftNav mobileOpen={mobileOpen} onMobileClose={handleMobileClose} />
                          <Box component="main" sx={{ flexGrow: 1, p: { xs: 1.5, sm: 2, md: 3 }, width: 0 }}>
                            <Switch>
                              <PrivateRoute exact path="/" component={Destination} />
                              <PrivateRoute exact path="/gallery" component={Gallery} />
                              <PrivateRoute exact path="/memory" component={Memory} />
                              <PrivateRoute exact path="/profile" component={Profile} />
                              <Route exact path="/" component={Destination} />
                              <Route exact path="/gallery" component={Gallery} />
                              <Route exact path="/register" component={Register} />
                              <Route exact path="/login" component={Login} />
                              <Route exact path="/memory" component={Memory} />
                              <Route exact path="/profile" component={Profile} />
                              <PrivateRoute exact path="/following" component={FollowingFeed} />
                              <PrivateRoute exact path="/following/manage" component={ManageFollowing} />
                              <Route exact path="/spots" component={Spot} />
                              <Route exact path="/spot/:spot_id" component={SpotDetails} />
                              <PrivateRoute exact path="/my-journeys" component={MyJourneys} />
                              <PrivateRoute exact path="/create/review" component={CreateSpotReview} />
                              <PrivateRoute exact path="/create/trip" component={CreateTrip} />
                              <Route exact path="/manage" component={Manage} />
                              <Route exact path="/destinations" component={Destination} />
                              <Route exact path="/destination/:destination_id" component={DestinationTrips} />
                              <Route exact path="/trip/:trip_id" component={TripDetail} />
                              <Route exact path="/review/:review_id" component={SpotReviewDetail} />
                            </Switch>
                            <Alert />
                          </Box>
                        </Box>
                      </Fragment>
                    </Router>
                  </AlertState>
                  </AdminState>
                </FriendState>
              </TagState>
            </TripState>
          </DestinationState>
        </SpotReviewState>
      </PostState>
    </AuthState>
  );
}

export default App;
